module.exports = __webpack_public_path__ + "static/assets/a3a641587a3c797ca626badeb2748885.svg";